export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^((0[1-9])|(1[0-9])|(2[0-2]))0[0-9]{2}$/i));
    }
}
